import React from 'react';
import s from '../../CartItem.scss';
import {CartItemDataHook} from '../../CartItem';
import {LineItemModel} from '../../../../../../domain/models/LineItem.model';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {useCurrencyFormatter} from '@wix/yoshi-flow-editor';

export const Price = ({
  lineItem,
  shouldShowCrossedOutPriceOnLineItemLevel,
}: {
  lineItem: LineItemModel;
  shouldShowCrossedOutPriceOnLineItemLevel: boolean;
}) => {
  const {supportModifiersOnCart, regionalSettings, cartModel} = useControllerProps().cartStore;
  const formatCurrency = useCurrencyFormatter({language: regionalSettings});

  const getBaseUnitPrice = () => {
    const modifiersTotalPriceAmount = lineItem.modifiersTotalPrice?.convertedAmount;
    if (!supportModifiersOnCart || modifiersTotalPriceAmount === 0) {
      return lineItem.price.formattedConvertedAmount;
    }

    const unitPriceAmount = lineItem.crossedOutPrice?.convertedAmount
      ? lineItem.crossedOutPrice.convertedAmount
      : lineItem.price.convertedAmount;

    const baseUnitPriceAmount = unitPriceAmount - modifiersTotalPriceAmount;
    return formatCurrency({value: baseUnitPriceAmount, currency: cartModel.paymentCurrencyCode});
  };

  return (
    <div className={s.prices}>
      {!shouldShowCrossedOutPriceOnLineItemLevel && lineItem.crossedOutPrice?.formattedConvertedAmount && (
        <span
          data-hook={CartItemDataHook.ComparePrice}
          data-wix-line-full-item-price={CartItemDataHook.ComparePrice}
          className={s.comparePrice}>
          {lineItem.crossedOutPrice.formattedConvertedAmount}
        </span>
      )}
      {lineItem.price.formattedConvertedAmount && (
        <span data-hook={CartItemDataHook.Price} className={s.price} data-wix-line-item-price={CartItemDataHook.Price}>
          {getBaseUnitPrice()}
        </span>
      )}
    </div>
  );
};
